import React, { useState, useEffect} from "react"
import styled from 'styled-components'
import { useFilterContext } from '../context/filter_context';
import {Button} from '../styles/Button'
import { useProductContext } from '../context/productcontext';
import { useLocation } from 'react-router-dom';
import { CiFilter } from "react-icons/ci";


const FilterSection = () => {
  const {filters:{text,Item,subcategory,category},all_products,updateFilterValue,clearFilters}=useFilterContext();
  const {categories, subcategories,items } = useProductContext();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const categoryFromUrl = params.get("category");
 
  const [sidebarOpen, setSidebarOpen] = useState(false);

 useEffect(() => {
    if (categoryFromUrl && category !== categoryFromUrl) {
      updateFilterValue({ target: { name: "category", value: categoryFromUrl } });
    }
    // run only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    

  //getting unique data for each field
  const getUniqueData=(data,property)=>{
     let newVal = data.map((curElem) => {
    const props=property.split(".");
    let value = curElem;
    for(let prop of props){
      value=value?.[prop];
    }
    return value?.toString().trim();
  })
    
// Remove undefined/null and sort alphabetically
  let uniqueVals = ["All", ...new Set(newVal.filter(Boolean))];
  return [
    uniqueVals[0], // "All"
    ...uniqueVals.slice(1).sort((a, b) =>
      b.toLowerCase().localeCompare(a.toLowerCase())
    ),
  ];    
  };

// Step 1: Filter by selected category
  const filteredByCategory =
    category === "All"
      ? all_products
      : all_products.filter(
          (product) => (product.category?.label|| "")?.toLowerCase() === category.toLowerCase()
        );

// Step 2: Filter by selected subcategory (within category)
  const filteredBySubcategory =
    subcategory === "All"
      ? filteredByCategory
      : filteredByCategory.filter(
          (product) => (product.subcategory?.label||"")?.toLowerCase() === subcategory.toLowerCase()
        );

// Step 3: Use this to generate the Item dropdown options
  const ItemOnlyData = getUniqueData(filteredBySubcategory, "Item");

// Subcategory dropdown depends only on selected category
  const subcategoryOnlyData = getUniqueData(filteredByCategory, "subcategory.label");

// Category dropdown is always from all_products
  const CategoryOnlyData = getUniqueData(all_products, "category.label");

useEffect(() => {
  let timer;
  const handleClickAnywhere = (event) => {
    // ✅ Don't close if click is inside sidebar
    if (event.target.closest(".filter-product")) return;

    // ✅ Don't close if click is on the toggle button
    if (event.target.closest(".sidebar-toggle")) return;

    // Otherwise close immediately
    setSidebarOpen(false);
  };

  if (sidebarOpen) {
    document.addEventListener("click", handleClickAnywhere);

    // ✅ Auto-close after 5 seconds if still open
      timer = setTimeout(() => {
        setSidebarOpen(false);
        }, 8000);
        } else {
          document.removeEventListener("click", handleClickAnywhere);
        }

      return () => {
          document.removeEventListener("click", handleClickAnywhere);
          clearTimeout(timer);
        };
      }, [sidebarOpen]);

  return (
   <Wrapper>   
    <div className='filter-selection'>      
      <div className='filter-search' autoComplete="off">
          <form onSubmit={(e)=>e.preventDefault()}>
            <input 
              type="text" 
              name="text" 
              value={text} 
              onChange={updateFilterValue} 
              placeholder='Search for Product'
            />
          </form> 

          {/* Show CiFilter only when sidebar is closed */}
          {!sidebarOpen && (
            <button 
              className="sidebar-toggle" 
              onClick={() => setSidebarOpen(true)}
            >
              <CiFilter/>
            </button>
          )}
        </div>
      <div className={`filter-product ${sidebarOpen ? "open" : ""}`}>       
              <div className="filter-category">
                <h3>Category</h3>
                <div>
                  
                  {/* Static "All" button */}
                  <button
                    type="button"
                    name="category"
                    value="All"
                    className={category === "All" ? "active" : ""}
                    onClick={updateFilterValue}
                  >
                    All
                  </button>

                  {categories.map((curElem) => (
                  <button
                    key={curElem._id}
                    type="button"
                    name="category"
                    value={curElem._id}   // send ID to backend
                    className={curElem._id === category ? "active" : ""}
                    onClick={updateFilterValue}
                  >
                    {curElem.label}     
                  </button>
                  ))}
                </div>
              </div>
              <div className="filter-Subcategory">
                <h3>Sub-Category</h3>
                <form action="#">
                <select
                  name="subcategory"
                  id="subcategory"
                  className="filter-Subcategory--select"
                  onChange={updateFilterValue}
                  value={subcategory}
                >
                  <option value="All">All Subcategories</option>
                  {subcategories
                    .filter((sc) => {
                      // ✅ Old logic: only show subcategories belonging to selected category
                      if (category === "All") return true;
                      return sc.category?._id === category;  // assumes backend subcategory has a category reference
                    })
                    .map((curElem) => (
                      <option key={curElem._id} value={curElem._id}>
                        {curElem.label}
                      </option>
                    ))}
                  </select>
                </form>

              </div>
              <div className="filter-item">
                    <h3>Item</h3>
                  <form action="#">
                     
                      <select
                      name="Item"
                      id="Item"
                      className="filter-Subcategory--select"
                      onChange={updateFilterValue}
                      value={Item}
                      >
                      <option value="All">All Items</option>
                      {items.map((curElem, index) => (
                        <option key={index} value={curElem}>
                          {curElem}
                        </option>
                      ))}
                    </select>
                </form>
              </div>
      <div className='filter-clear'>
        <Button className='btn' onClick={clearFilters}>Clear Filter
        </Button>
      </div>
      </div>   
    </div>
   </Wrapper>
  )
}
const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 2rem 0;
  gap: 2rem; 
  justify-content: center;
  align-items: center;

 h3 {
    padding: 2rem 0;
    font-weight: bold;
    }
    
  
.sidebar-toggle {
  display: none; 
  z-index: 99;
  background: transparent;
  border: none;
  cursor: pointer;
  &:hover {
  
  color: ${({ theme }) => theme.colors.btn};
    }
}

.filter-category {
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
          
      button {
        border: none;
        background-color: ${({ theme }) => theme.colors.white};
        text-transform: capitalize;
        cursor: pointer;
       
        &:hover {
        color: ${({ theme }) => theme.colors.btn};
        }
      }

      .active {
        border-bottom: 1px solid #000;
        color: ${({ theme }) => theme.colors.btn};
      }
    }
  }

  .filter-Subcategory--select {
    padding: 0.3rem 1.2rem;
    font-size: 1.6rem;
    color: ${({ theme }) => theme.colors.text};
    border: 1px solid ${({ theme }) => theme.colors.border};
    box-shadow: ${({ theme }) => theme.colors.shadowSupport};
    text-transform: capitalize;
    }

  .filter-clear .btn {
    margin-top: 2rem;
    background-color: #ec7063;
    color: #000;
    }

  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;   
    z-index: 1000; 
    }
  
@media (max-width: ${({ theme }) => theme.media.mobile}) {

padding: 0;
gap: 0;

.filter-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* Style the input field */
.filter-search input {  
  width: 100%;       
  font-size: 1.4rem;
  padding: 0.5rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
}

/* Style the filter toggle button */
.sidebar-toggle {  
  display: flex;
  font-size: 5rem;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;   
  background: transparent;
  border: none;
  cursor: pointer; 
}


.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
}
   
.filter-product {
  position: fixed;
  top: 0;
  left: 0;   
  height: 100%;
  width: 80%;
  max-width: 20rem;
  background-color: ${({ theme }) => theme.colors.bgl};
  border-radius: 0 1rem 1rem 0; 
  border: 2px solid ${({ theme }) => theme.colors.border};
  padding: 1rem;
  box-shadow: 2px 0 6px rgba(0,0,0,0.2); 
  transform: translateX(-100%); 
  transition: transform 0.3s ease-in-out;
  z-index: 999;
  }
   

.filter-product.open {
  transform: translateX(0); 
  }

.filter-category {
  div {             
  button {
  border: none;
  background-color: ${({ theme }) => theme.colors.bgl};      
  }
  
}
`;

export default FilterSection
